export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const ROLES = ['agent', 'administrator'];

export const LABEL_PERMISSIONS = ['administrator', 'cx_engineer'];

export const ONBOARDING_GUIDE_PERMISSIONS = [
  'administrator',
  'agent',
  'supervisor',
  'cx_engineer',
  'report_manage',
];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const PORTAL_CREATE_PERMISSIONS = ['administrator', PORTAL_PERMISSIONS];

export const PORTAL_MANAGE_PERMISSIONS = ['administrator', PORTAL_PERMISSIONS];

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
    ],
  },
};

// The only roles `userCanAccessClaudia` (routes/index.js) accepts: any other role on a
// claudia_only account falls outside the curated routing entirely. The guard matches it
// against `account.permissions` while the agent pickers match it against role ids — the
// two vocabularies coincide for these two strings only, so widening the list is not
// mechanical.
export const CLAUDIA_ONLY_ROLES = ['administrator', 'cx_engineer'];

export const CLAUDIA_ACCESS_PERMISSIONS = ['administrator', 'cx_engineer'];
